// extracted by mini-css-extract-plugin
export var clauseRow = "_c2-6";
export var emptyState = "_c2-b";
export var filterContent = "_c2-a";
export var filterGroup = "_c2-1";
export var filterGroupContainer = "_c2-0";
export var nestedGroup = "_c2-2";
export var nestedGroupDepth1 = "_c2-3";
export var nestedGroupDepth2 = "_c2-4";
export var nestedGroupDepth3 = "_c2-5";
export var operatorAnd = "_c2-8";
export var operatorOr = "_c2-9";
export var operatorToggle = "_c2-7";
export var removeGroupButton = "_c2-c";